<template>
  <svg
    class="va-icon-svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="m5 12 4 4L19 6" />
  </svg>
</template>

<script setup lang="ts">
/**
 * Inline-SVG replacement for the Material Icons glyph `va-check`.
 *
 * `VaCheckbox` renders this icon (via `<VaIcon name="va-check" />`) when
 * the model value is `true`. Vuestic's default lookup falls back to a
 * Material Icons font ligature — `<i class="material-icons">check</i>` —
 * but we do NOT load the Material Icons font (≈300 KB), so the fallback
 * renders the literal text "check" inside the checkbox square. That's
 * the bug visible on `/settings`. Registering this component as the
 * `va-check` alias's `component` (see `main.ts`) tells Vuestic to render
 * this SVG instead, matching the zero-font contract used by `AppIcon`.
 *
 * `stroke="currentColor"` picks up the icon color Vuestic sets via
 * `--va-checkbox-selected-icon-color`. The `1em` width/height lets
 * Vuestic's size-based `font-size/height/line-height` styles scale the
 * glyph without us hardcoding dimensions.
 */
export interface VuesticCheckboxCheckIconProps {}

defineProps<VuesticCheckboxCheckIconProps>()
</script>
